module.exports = __webpack_public_path__ + "img/XT-EquipoDeOxicorte.229e300f.png";